import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import paymentsService from '../../services/PaymentServices';
import Loading from '../../components/feedback/Loading';
import { Helmet } from 'react-helmet';
import utils from '../../utils';
import PaymentInfo from './PaymentInfo';
import DeliverySecurity from './DeliverySecurity';

function DeliveryConfirmationPage() {
    const { txRef } = useParams();
    const [payment, setPayment] = useState()
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (txRef) {
            getPayment(txRef)
        }
        console.log(txRef);

    }, [txRef])

    useEffect(() => {
        console.log(payment);

    }, [payment])

    const getPayment = (ref) => {
        setError()
        paymentsService.reconfirmPayment(ref).then(
            res => {
                setPayment(res.data)
                setLoading(false)
            },
            err => {
                setError(err)
                setLoading(false)
            }
        )
    }
    return (
        <div>
            <Helmet>
                <title>Delivery Confirmation Page - {utils.siteName}</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <div className="flex items-center justify-center min-h-[50vh] w-full px-4 py-4">
                <div className="bg-white dark:bg-slate-900 p-4 lg:p-8 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg w-11/12 md:w-8/12 lg:w-5/12">
                    <div className="space-y-3">
                        <h1 className="text-2xl text-primary font-bold">Delivery Overview</h1>
                        <p className="text-gray-600 mt-2">
                            Verify the recipient’s identity by confirming the delivery code before completing the drop-off.
                        </p>

                        {loading ? (
                            <div className="flex justify-center py-6">
                                <Loading />
                            </div>
                        ) : error ? (
                            <div className="py-4 space-y-6">
                                <div className="flex justify-center">
                                    <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl shadow-primary/10">

                                        <div className="absolute top-[-20%] right-[-20%] w-64 h-64 bg-primary/20 rounded-full blur-3xl"></div>
                                        <div className="absolute bottom-[-20%] left-[-20%] w-64 h-64 bg-accent-red/20 rounded-full blur-3xl"></div>
                                        <div className="relative not-found-bg z-5 w-full h-full bg-center bg-cover bg-no-repeat" data-alt="3D playful illustration of a floating cardboard box in space with orange accent lighting">
                                            <div className="absolute inset-0 bg-gradient-to-t from-background-light/80 to-transparent dark:from-background-dark/80"></div>
                                        </div>
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <h1 className="text-[120px] md:text-[160px] font-extrabold text-white mix-blend-overlay opacity-90 leading-none select-none">404</h1>
                                        </div>
                                    </div>
                                </div>

                                <div className="container mx-auto px-4 text-center">
                                    <p className="text-red-600">{'They Order requested could not be found! Contact Admin.'}</p>
                                </div>
                                <div className="flex justify-center">
                                    <div className="flex flex-col sm:flex-row gap-4 w-full justify-center max-w-[480px]">
                                        <Link className="flex flex-1 cursor-pointer items-center justify-center rounded-xl h-12 px-6 bg-primary hover:bg-orange-600 text-white text-base font-bold leading-normal tracking-[0.015em] transition-all shadow-lg shadow-primary/25 transform hover:-translate-y-0.5" to="/">
                                            Return to Homepage
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        ) : (
                            <div className="py-4 space-y-7">
                                {payment && (
                                    <>
                                        <PaymentInfo 
                                            payment={payment} 
                                            updatePage={getPayment}/>
                                        <DeliverySecurity payment={payment} />
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeliveryConfirmationPage